import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiFiltersConfig } from '@/data/landingConfig/landingAiFiltersConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiFilters } from './schemaObject';

interface Props {}
const AiFilters: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiFilters} />
			<LandingTemplate
				data={landingAiFiltersConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiFilters;
